// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"d2818067","893":"76c9203e"}[chunkId] + ".chunk.css";
};